// extracted by mini-css-extract-plugin
export default {"wrapperControlExpiring":"ControlExpiring_wrapperControlExpiring__drY+K","expirationDate":"ControlExpiring_expirationDate__sAM9k"};